module.exports = __webpack_public_path__ + "media/images/icons/icon-distress-a20029724eb19a1b134b80099fe2510d.svg";